// extracted by mini-css-extract-plugin
module.exports = {"text-area":"styles_text-area__15g49","cross-icon":"styles_cross-icon__TmNIL"};